<template>
  <v-dialog v-model="dialog" max-width="1500" >
    <v-card>
      <v-card-title class="border-bottom">
        Resim Galerisi
        <v-spacer></v-spacer>
        <v-btn @click="closeDialog()" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>

      </v-card-text>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ProductImageGalleryDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentProp: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      searchText: "",
      totalDebit: 0,
      totalCredit: 0,
      totalBalance: 0,
      currentActionDetailListDialog: false,
      currentActionProp: null
    };
  },
  methods:{
    closeDialog() {
      this.dialog = false;
      this.searchText = null;
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);

    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    }
  }
}
</script>

<style scoped>

</style>
